import {kGamesNumbers} from "../../constants/numbers";

// ---- Is number key item disabled
export function isNumberKeyDisabled(userAnswer) {
    return !(userAnswer.length < kGamesNumbers.relativeSumAnswerMax && userAnswer[0] !== "0")
}